import React, { useState, useEffect, useRef } from 'react';
import { Form, ImageUploader, Toast, Dialog } from 'antd-mobile';

function ImageUploaderH5(props) {
    const { onChange, name, label, required, maxCount, accept, value } = props;
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const onChangeRef = useRef(onChange);

    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);

    // 修改这里的初始化逻辑
    useEffect(() => {
        if (value && value.length > 0) {
            const initialFiles = Array.isArray(value) ? value : [value];
            console.log(initialFiles);
            
            setFileList(initialFiles.map(url => ({
                url: url.startsWith('http') ? url : 
                     url.startsWith('/api') ? url.replace('/api', 'http://fxapi.zzddww.com') :
                     `http://fxapi.zzddww.com/assets/images/application/${url}`,
                status: 'done',
                serverPath: url.replace('/api/assets/images/application/', '')
                          .replace('http://fxapi.zzddww.com/assets/images/application/', '')
            })));
        } else {
            setFileList([]);
        }
    }, [value]);

    const mockUpload = async (file) => {
        setUploading(true);
        try {
            const formData = new FormData();
            formData.append('image_file[]', file);           

            const response = await fetch('/api/ReactApi/multiple_upload_image', {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }).then(res => res.json());

            if (response.Status === 'success') {
                Toast.show({ icon: 'success', content: '上传成功' });
                
                const resultImages = Array.isArray(response.Result) ? response.Result : [response.Result];
                const newFiles = resultImages.map(img => ({
                    url: `/api/assets/images/application/${img}`,
                    status: 'done',
                    serverPath: img
                }));

                const updatedFileList = [...fileList, ...newFiles];
                setFileList(updatedFileList);
                
                // 直接传递 serverPath 数组给父组件
                const serverPaths = updatedFileList
                    .filter(f => f.status === 'done')
                    .map(f => f.serverPath);
                onChangeRef.current(serverPaths);

                return newFiles[0];
            }
            throw new Error(response.Message || '上传失败');
        } catch (error) {
            Toast.show({ icon: 'fail', content: error.message });
            return {
                url: URL.createObjectURL(file),
                status: 'error'
            };
        } finally {
            setUploading(false);
        }
    };

    const handleChange = (files) => {
        setFileList(files);
        
        // 直接计算当前所有已完成图片的 serverPath
        const serverPaths = files
            .filter(file => file.status === 'done')
            .map(file => file.serverPath);
            
        onChangeRef.current(serverPaths);
    };

    const confirmDelete = (file) => {
        return Dialog.confirm({
            content: '确定要删除这张图片吗？',
        });
    };

    return (
        <Form.Item
            name={name}
            label={label}
            required={required}
        >
            <ImageUploader
                value={fileList}
                onChange={handleChange}
                upload={mockUpload}
                maxCount={maxCount || 5}
                disabled={uploading}
                accept={accept || 'image/*'}
                onDelete={confirmDelete}
                beforeUpload={(file) => {
                    const isLt2M = file.size / 1024 / 1024 < 100;
                    if (!isLt2M) {
                        Toast.show('图片大小不能超过100MB');
                        return null;
                    }
                    return file;
                }}
                
            />
        </Form.Item>
    );
}

export default ImageUploaderH5;